import { env } from "@/lib/env";

const TRAILING_SLASH_RE = /\/$/;

/**
 * Where the API sits on the app's own origin when the build names no API URL:
 * the dev server, `vite preview` (the hermetic E2E) and the desktop shell serve
 * the app and proxy this prefix to the API's routes, stripping it.
 */
const SAME_ORIGIN_API_PREFIX = "/api";

/** The API's root: the absolute VITE_API_URL, else the same-origin prefix. */
export function getApiRoot(): string {
  const base = env.VITE_API_URL?.replace(TRAILING_SLASH_RE, "");
  return base || SAME_ORIGIN_API_PREFIX;
}

export function getApiUrl(path: string): string {
  return `${getApiRoot()}${path.startsWith("/") ? path : `/${path}`}`;
}
